/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FilterHistoryUpdateRequest model module.
 * @module model/FilterHistoryUpdateRequest
 * @version 1.0.0
 */
class FilterHistoryUpdateRequest {
    /**
     * Constructs a new <code>FilterHistoryUpdateRequest</code>.
     * @alias module:model/FilterHistoryUpdateRequest
     */
    constructor() { 
        
        FilterHistoryUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FilterHistoryUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FilterHistoryUpdateRequest} obj Optional instance to populate.
     * @return {module:model/FilterHistoryUpdateRequest} The populated <code>FilterHistoryUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FilterHistoryUpdateRequest();

            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('is_named')) {
                obj['is_named'] = ApiClient.convertToType(data['is_named'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FilterHistoryUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FilterHistoryUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }

        return true;
    }


}



/**
 * @member {String} title
 */
FilterHistoryUpdateRequest.prototype['title'] = undefined;

/**
 * @member {Boolean} is_named
 */
FilterHistoryUpdateRequest.prototype['is_named'] = undefined;






export default FilterHistoryUpdateRequest;

